




















import { Component, Mixins, Prop } from "vue-property-decorator";
import { FormMixin } from "./formMixin";

@Component({
  mixins: [FormMixin]
})
export default class FormTextarea extends Mixins(FormMixin) {
  @Prop({ default: "" }) public description: any;
  @Prop({ default: "text" }) public type!: string;
  @Prop({ default: "md" }) public size!: string;
  @Prop({ default: null }) public maxlength!: number;
  @Prop({ default: 3 }) public rows!: number;
  @Prop({ default: 6 }) public maxRows!: number;
}
